<script lang="ts">
	// Services
	import { format } from 'svelte-i18n';

	// Stores
	import { network } from 'src/stores/session/native-bridge';

	// Design system components
	import { Toolbar, Button, IconButton, Breadcrumbs, Text } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';

	export let inclusionData;
	export let mode = false;
	export let scanNetwork;

	const discoveredDevicesBreadcrumbs = [
		{
			label: !inclusionData
				? $format('discovered_devices', { default: 'discovered devices' })
				: capFirstChar(
						$format('via_wifi_scan', {
							default: 'Scan Network',
						}),
					),
		},
	];

	$: buttonText = mode
		? $format('button_discovered_list', { default: 'discovered list' })
		: $format('button_add_by_ip', { default: 'add by ip' });

	const handleToggle = () => {
		if (inclusionData) inclusionData.selected = undefined;
		mode = !mode;
	};

	// const title =
	// 	$format('label_connect_to_network') + $format('enable_location_prompt');

	const handleRefresh = () => {
		scanNetwork();
	};
</script>

{#if !inclusionData}
	<Toolbar class="mb-m" hideSlotBottom>
		<svelte:fragment slot="breadcrumbs">
			<Breadcrumbs
				aria-label={$format('label_discovered_devices', { default: 'Discovered devices' })}
				class="text-capitalize"
				links={discoveredDevicesBreadcrumbs}
			/>
		</svelte:fragment>

		<svelte:fragment slot="rightSide">
			{#if !mode}
				<IconButton
					aria-label={$format('button_refresh_scan', {
						default: 'Button refresh scan',
					})}
					icon="fas fa-arrows-rotate"
					on:click={handleRefresh}
					disabled={$network !== 'wifi'}
				/>
			{/if}
			<Button class="align-self-center text-capitalize" size="m" on:click={handleToggle}>
				{buttonText}
			</Button>
		</svelte:fragment>
	</Toolbar>
{:else}
	<div class="d-flex align-items-center justify-content-between mb-m">
		<Text element="h2">
			{capFirstChar(
				$format('via_wifi_scan', {
					default: 'Scan Network',
				}),
			)}
		</Text>
		<div class="d-flex align-items-center">
			{#if !mode}
				<IconButton
					aria-label={$format('button_refresh_scan', {
						default: 'Button refresh scan',
					})}
					class="mr-s"
					icon="fas fa-arrows-rotate"
					on:click={handleRefresh}
					disabled={$network !== 'wifi'}
				/>
			{/if}
			<Button class="align-self-center text-capitalize" size="m" on:click={handleToggle}>
				{buttonText}
			</Button>
		</div>
	</div>
{/if}
